"use strict";
require('../../../ui/js/api-header-injector.js');
require('hacktimer');
require('bootstrap');
require('bootstrap-css');
require('webpack-jquery-ui');
require('webpack-jquery-ui/css');
require('../../../ui/js/chart.min.js');
require('../../../ui/js/jquery-ui.js');
require('../../../ui/js/jquery.mCustomScrollbar.js');
require('../../../ui/js/charts.js');
window['lang'] = getUriParameter('lang');
require('../../../ui/js/language.js');
require('../js/script.js');
require('../js/menu.js');
require('../js/league.js');
require('../../../ui/js/iframe-script.js');
window['API_URL'] = API_URL;
window['$'] = require('jquery');
window['jquery'] = window['$'];
window['jQuery'] = window['$'];
var SPECIAL_API_URL = 'https://api.elbet.us/index.php';
var SPECIAL_API_URL_DOMAINS = ['online.try.everymatrix.elbet.us'];
if (SPECIAL_API_URL_DOMAINS.indexOf(window.location.hostname) >= 0) {
    window['API_URL'] = SPECIAL_API_URL;
    console.log('Special API URL for domain ' + window.location.hostname + ' : ' + SPECIAL_API_URL);
}
require.context('../img', true, /\.(gif|png|jpe?g|svg)$/i);
require('../scss/' + CSS_THEME + '.scss');
switch (window.location.hostname) {
    case BABAIJEBU_DOMAIN:
        try {
            require('../scss/' + CSS_THEME + '/' + BABAIJEBU_DOMAIN + '.scss');
        }
        catch (e) {
            console.info(e);
        }
        break;
    case AMELCO_DOMAIN:
        try {
            require('../scss/' + CSS_THEME + '/' + AMELCO_DOMAIN + '.scss');
        }
        catch (e) {
            console.info(e);
        }
        break;
}
require('../../../ui/css/jquery.mCustomScrollbar.css');
window['customLoggedIn'] = false;
window['customToken'] = '';
window['token'] = getUriParameter('token');
function getUriParameter(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    }
    else {
        return decodeURI(results[1]) || 0;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/ts/main.ts
// module id = 1997
// module chunks = 4